"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const uniqueId_1 = tslib_1.__importDefault(require("lodash/uniqueId"));
function default_1({ name, result, basicResultQuery, params }) {
    if (basicResultQuery === '')
        return;
    const fragmentName = `${name}_${(0, uniqueId_1.default)()}`;
    const text = `fragment ${fragmentName} on ${result} ${basicResultQuery}`;
    return (0, graphql_tag_1.default)([text]);
}
exports.default = default_1;
//# sourceMappingURL=getFragment.js.map